import styled, { css } from "styled-components";
import { DatePickerStyledProps, VIEW } from "./types";

export const CommonButtonStyle =
	"w-full items-center justify-center !rounded-md !border-2 !border-gray-200 !p-6 text-gray-800";

export const DatePickerStyled = styled.div<DatePickerStyledProps>`
	position: relative;
	padding: 1.25rem 1.5rem 6rem; /* px-6 py-5 pb-24 */
	background-color: white;
	border-radius: 0.75rem; /* rounded-xl */

	${({ calendarView }) => css`
		min-height: ${calendarView === VIEW.MONTH ? "500px" : "0"};
	`}

	${({ ranged }) =>
		!ranged &&
		css`
			box-shadow:
				0 1px 2px rgba(16, 24, 40, 0.05),
				0 1px 3px rgba(16, 24, 40, 0.1);
		`}

	${({ ranged }) =>
		ranged &&
		css`
			padding-bottom: 1rem; /* pb-4 */
		`}

  .react-calendar {
		width: 300px;
		max-width: 300px;
		min-width: 300px;
	}

	.event-date {
		position: relative;
	}

	.event-date::before {
		content: " ";
		position: absolute;
		bottom: 6px;
		left: 50%;
		transform: translateX(-50%);
		border-radius: 50%;
		width: 4px;
		height: 4px;
		z-index: 11;
		background-color: #175cd3; /* bg-royal-blue */
	}

	.react-calendar__month-view__days {
		row-gap: 0.25rem; /* gap-y-1 */
		display: grid;
	}

	.react-calendar__tile {
		transition: none;
		height: max-content;
		width: max-content;
		overflow: visible !important;
		outline: none;
		border-radius: 9999px;
	}

	.react-calendar__tile abbr {
		position: relative;
		padding: 0.5rem;
		height: 2.5rem;
		width: 2.5rem;
		border-radius: 9999px;
		font-size: 0.875rem;
		line-height: 2rem;
		z-index: 10;
		&:hover {
			border-radius: 0.5rem !important; /* rounded-lg */
			transition-property: all !important; /* transition */
			background-color: #bfdbfe !important; /* blue-200 */
  			color: #1d4ed8 !important;           /* blue-700 */
		}
	}

	react-calendar__year-view__months__month abbr {
		display: none; !important
	}

	.react-calendar__tile--active::before {
		background-color: white;
	}

	.react-calendar__tile--active abbr {
		background-color: #175cd3 !important; /* bg-royal-blue */
		color: white !important;
	}

	.react-calendar__month-view__weekdays {
		text-align: center;
		margin-bottom: 0.75rem;
	}

	.react-calendar__month-view__weekdays abbr {
		font-size: 14px;
		text-decoration: none;
		font-weight: 500;
	}

	.react-calendar__month-view__days__day--neighboringMonth {
		color: #9ca3af; /* text-gray-400 */
	}

	.react-calendar__month-view__days__day {
		background-color: transparent !important;
		border: 1px solid transparent;
	}

	.react-calendar__tile--range {
		border-radius: 0px !important;
		background-color: #f3f4f6 !important; /* bg-gray-100 */
		color: black !important;
	}

	.react-calendar__tile--range abbr {
		background-color: #f3f4f6 !important;
		color: black !important;
	}

	.react-calendar__tile--range::before {
		background-color: #175cd3;
	}

	.react-calendar__tile--rangeStart,
	.react-calendar__tile--rangeEnd {
		position: relative;
		background-color: #175cd3 !important;
		color: white !important;
		border-radius: 9999px !important;
	}

	.react-calendar__tile--rangeStart::after,
	.react-calendar__tile--rangeEnd::after {
		content: " ";
		position: absolute;
		background-color: #f3f4f6;
		width: 100%;
		height: 100%;
		top: 0;
	}

	.react-calendar__tile--rangeEnd::after {
		right: 1.25rem;
	}

	.react-calendar__tile--rangeStart::before,
	.react-calendar__tile--rangeEnd::before {
		background-color: white;
	}

	.react-calendar__tile--rangeStart abbr,
	.react-calendar__tile--rangeEnd abbr,
	.react-calendar__tile--rangeBothEnds abbr {
		position: relative;
		background-color: #175cd3 !important;
		color: white !important;
		border-radius: 9999px;
	}

	.react-calendar__tile--rangeBothEnds {
		position: relative;
		background-color: #175cd3 !important;
		color: white !important;
		border-radius: 9999px;
	}

	.react-calendar__tile--rangeBothEnds::after {
		content: " ";
		position: absolute;
		background-color: #f3f4f6;
		width: 100%;
		height: 100%;
		top: 0;
		right: 1.25rem;
		display: none;
	}

	.react-calendar__tile--rangeBothEnds::before {
		background-color: white;
	}

	.react-calendar__tile--now {
		border: 2px solid #F87171;
	}

	button.react-calendar__tile--now:disabled {
		border: 2px solid #FCA5A5 !important;
		&:hover {
			border-radius: 9999px !important;
			transition-property: all !important; /* transition */
			background-color: transparent !important; /* bg-gray-100 */
		}
	}

	button:disabled,
	button:disabled abbr {
		&:hover {
			border-radius: 0.5rem !important;
			border-color: transparent;
			transition-property: all !important; /* transition */
			background-color: transparent !important; /* bg-gray-100 */
  			color: #d1d5db !important; /* !text-gray-300 */
		}
		color: #9CA3AF; 
		cursor: not-allowed; 
		opacity: 0.6; 
	}

	button {
		&:hover {
			border-radius: 0.5rem !important;
			transition-property: all !important;
			background-color: #bfdbfe !important;
			color: #1d4ed8 !important;
		}
	}

	.min-date-tile,
	.min-date-tile abbr {
		border-radius: 0.5rem !important;
			border-color: green;
	}

	.min-date-tile {
	position: relative;
	}

	.min-date-tile span::after {
		content: attr(data-tooltip);
		position: absolute;
		bottom: 125%;
		left: 50%;
		transform: translateX(-50%);
		background: rgba(0, 0, 0, 0.75);
		color: #fff;
		font-size: 0.75rem;
		padding: 0.25rem 0.5rem;
		border-radius: 0.25rem;
		opacity: 0;
		transition: opacity 0.2s ease;
		white-space: nowrap;
		pointer-events: none;
	}

	.min-date-tile:hover span::after {
		opacity: 1;
	}
`;
